import { useEffect, useRef } from 'react';

// Six single-character boxes that behave like one field: typing advances,
// backspace on an empty box steps back, and pasting a code fills across boxes
// rather than dropping it all into the first.
export function CodeInput({ length = 6, value, onChange }) {
  const refs = useRef([]);

  useEffect(() => {
    refs.current = refs.current.slice(0, length);
  }, [length]);

  const chars = Array.from({ length }, (_, i) => value[i] || '');

  const setChar = (index, char) => {
    const next = chars.slice();
    next[index] = char;
    onChange(next.join('').slice(0, length));
  };

  const handleInput = (index) => (e) => {
    const digits = e.target.value.replace(/[^0-9]/g, '');
    if (!digits) {
      setChar(index, '');
      return;
    }
    setChar(index, digits[digits.length - 1]);
    if (index < length - 1) refs.current[index + 1]?.focus();
  };

  const handleKeyDown = (index) => (e) => {
    if (e.key === 'Backspace' && !chars[index] && index > 0) {
      refs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (index) => (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData('text').replace(/[^0-9]/g, '');
    if (!pasted) return;
    const next = chars.slice();
    for (let i = 0; i < length - index && i < pasted.length; i += 1) {
      next[index + i] = pasted[i];
    }
    onChange(next.join(''));
    refs.current[Math.min(index + pasted.length, length - 1)]?.focus();
  };

  return (
    <div className="verify-code-inputs">
      {chars.map((char, i) => (
        <input
          // Index is the identity here: the boxes are positional and the list
          // never reorders.
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          ref={(el) => {
            refs.current[i] = el;
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]"
          maxLength={1}
          value={char}
          onChange={handleInput(i)}
          onKeyDown={handleKeyDown(i)}
          onPaste={handlePaste(i)}
        />
      ))}
    </div>
  );
}
